import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Plus, X } from "lucide-react";
import { Pipeline } from "@/types/pipeline";

interface PipelineCreatedModalProps {
  isOpen: boolean;
  onClose: () => void;
  pipeline: Pipeline | null;
  onAddStages: () => void;
}

export function PipelineCreatedModal({
  isOpen,
  onClose,
  pipeline,
  onAddStages,
}: PipelineCreatedModalProps) {
  if (!pipeline) return null;

  const handleAddStages = () => {
    onAddStages();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="h-10 w-10 text-green-600" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">
            ¡Pipeline Creado Exitosamente!
          </DialogTitle>
          <DialogDescription className="text-center text-base pt-2">
            El pipeline{" "}
            <span className="font-semibold text-slate-900">
              "{pipeline.name}"
            </span>{" "}
            ha sido creado correctamente.
          </DialogDescription>
        </DialogHeader>

        <div className="py-6 text-center">
          <p className="text-sm text-slate-600 text-center">
            Ahora puedes agregar etapas para organizar el flujo de trabajo de
            este pipeline.
          </p>
        </div>

        <DialogFooter className="sm:justify-center gap-3 sm:space-x-0">
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full sm:w-auto"
          >
            <X className="h-4 w-4 mr-2" />
            Hacerlo después
          </Button>
          <Button
            onClick={handleAddStages}
            className="w-full sm:w-auto bg-slate-900 hover:bg-black"
          >
            <Plus className="h-4 w-4 mr-2" />
            Agregar Etapas
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
